export default __webpack_public_path__ + "static/media/sel-3-5-icon.04a8817f347b7a920b8ee1396a01d115.svg";